import * as z from 'zod';
import { SummaryViewSchema } from './summary-view';

/** Contract between the demo page and the Pages Functions. Both sides parse with these. */

export const API_ERROR_STATUS = {
  bad_request: 400,
  captcha: 403,
  origin: 403,
  not_found: 404,
  conversation_mismatch: 409,
  ip_limit: 429,
  day_limit: 429,
  geo_blocked: 451,
  misconfigured: 500,
  upstream: 502,
} as const;
export type ApiErrorCode = keyof typeof API_ERROR_STATUS;

const errorCodes = Object.keys(API_ERROR_STATUS) as [ApiErrorCode, ...ApiErrorCode[]];
export const ApiErrorSchema = z.object({ error: z.enum(errorCodes) });

export const SessionRequestSchema = z.object({ turnstileToken: z.string().min(1) });
export type SessionRequest = z.infer<typeof SessionRequestSchema>;

export const SessionResponseSchema = z.object({
  conversationToken: z.string().min(1),
  demoId: z.uuid(),
});
export type SessionResponse = z.infer<typeof SessionResponseSchema>;

export const SummaryRequestSchema = z.object({
  demoId: z.uuid(),
  /** From the SDK's onConnect callback. */
  conversationId: z.string().min(1),
});
export type SummaryRequest = z.infer<typeof SummaryRequestSchema>;

export const SummaryResponseSchema = z.discriminatedUnion('status', [
  z.object({ status: z.literal('pending') }),
  z.object({ status: z.literal('done'), view: SummaryViewSchema }),
]);
export type SummaryResponse = z.infer<typeof SummaryResponseSchema>;
